import type { SoundId } from './sounds'
import { playSound } from '@/src/utils/soundPlayer'

const CHARACTER_JUMP_SOUNDS = [
    'characterJump1',
    'characterJump2',
    'characterJump3',
] as const satisfies readonly SoundId[]

const CHARACTER_LANE_SWITCH_SOUNDS = [
    'characterLaneSwitch1',
    'characterLaneSwitch2',
    'characterLaneSwitch3',
] as const satisfies readonly SoundId[]

const CHARACTER_AIR_SWITCH_SOUNDS = [
    'characterAirSwitch1',
    'characterAirSwitch2',
    'characterAirSwitch3',
] as const satisfies readonly SoundId[]

const CHARACTER_CONFIG_SOUNDS = [
    'characterConfig1',
    'characterConfig2',
    'characterConfig3',
] as const satisfies readonly SoundId[]

function pickRandomSound(sounds: readonly SoundId[]): SoundId {
    return sounds[Math.floor(Math.random() * sounds.length)]
}

export function playCharacterJumpSound(): void {
    playSound(pickRandomSound(CHARACTER_JUMP_SOUNDS))
}

export function playCharacterLaneSwitchSound(): void {
    playSound(pickRandomSound(CHARACTER_LANE_SWITCH_SOUNDS))
}

export function playCharacterAirSwitchSound(): void {
    playSound(pickRandomSound(CHARACTER_AIR_SWITCH_SOUNDS))
}

export function playCharacterConfigSound(): void {
    playSound(pickRandomSound(CHARACTER_CONFIG_SOUNDS))
}
